import React from 'react';
import { defaultAdImage } from '../utils/defaultImages';

type Props = {
    img: string | undefined;
    className?: string;
};
const altText = (img: string | undefined) =>
    img
        ? 'Annonsebilde'
        : 'FINN standard annonsebilde illustrert med en minimalistisk illustrasjon av fjell og skyer i blåtoner';

const AdImage = ({ img, className }: Props) => (
    <img alt={altText(img)} src={img || defaultAdImage} className={className} />
);

export default AdImage;
